module.exports = __webpack_public_path__ + "assets/img/collection1.fe8d53e9.svg";